import { useEffect } from "react";
import { useParams } from "react-router-dom";
import { Analysis } from "../modules/samples/@types";
import { generateEndpoint } from "../modules/samples/util";

type Props = {
  analysis: Analysis;
  active: string;
  defaultSection: string;
  setActive: (item: string) => void;
};

const useAnalysisNavigation = ({ analysis, active, setActive }: Props) => {
  const { hash, sourceId } = useParams();

  const generateEndpointForSection = (section: string) =>
    generateEndpoint(hash, sourceId, analysis, section);

  useEffect(() => {
    if (active) {
      setActive(active);
    }
  }, [active]);

  return { generateEndpointForSection };
};

export default useAnalysisNavigation;
